<template>
  <el-form
    :model="form"
    ref="form"
    class="dialog-form-default"
    :disabled="disabledForm"
  >
    <div class="row">
      <div class="col-md-6 col-12">
        <el-form-item
          :label="L10n('shipper-name')"
          prop="shipperName"
          class="material-style"
          :rules="getValidationRule('required')"
        >
          <el-input
            :value="form.shipperName"
            @input="form.shipperName = valueTrimLeft($event)"
            @change="updateModelItem('shipperName', { required: true })"
          />
        </el-form-item>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 col-sm-6 col-12">
        <el-form-item
          :label="L10n('contact-name')"
          prop="contactName"
          class="material-style"
        >
          <el-input
            :value="form.contactName"
            @input="form.contactName = valueTrimLeft($event)"
            @change="updateModelItem('contactName', { required: false })"
          />
        </el-form-item>
      </div>
      <div class="col-md-3 col-sm-6 col-12">
        <el-form-item
          :label="L10n('contact-phone')"
          prop="contactPhone"
          class="material-style"
        >
          <el-input
            :value="form.contactPhone"
            @input="form.contactPhone = valueTrimLeft($event)"
            @change="updateModelItem('contactPhone', { required: false })"
          />
        </el-form-item>
      </div>
    </div>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'

export default {
  name: 'FormGeneralShippers',
  mixins: [Form]
}
</script>
